// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* WARNING: This section must be updated if _variables.ts is changed */
/* PERCENTAGE COLOURS */
.timeline {
  height: 100%;
}

.visibility-indicator {
  display: inline-flex;
  align-items: center;
  border-radius: 6px;
  padding: 0.12rem 0.25rem;
  font-size: 0.7rem;
  font-weight: 500;
  margin-right: 0.25rem;
  cursor: pointer;
}
.visibility-indicator.internal {
  background-color: #f9fafb;
  color: #4b5563;
  box-shadow: inset 0 0 0 1px rgba(107, 114, 128, 0.1);
}
.visibility-indicator.external {
  background-color: #fefce8;
  color: #854d0e;
  box-shadow: inset 0 0 0 1px rgba(217, 119, 6, 0.2);
}

.add-comment-btn {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  padding: 0.25rem 0.5rem;
  font-size: 0.7rem;
  font-weight: 500;
  margin-right: 0.25rem;
}

.timeline-avatar {
  position: relative;
  margin-top: 0.75rem;
  height: 1.75rem;
  width: 1.75rem;
  flex: none;
  border-radius: 50%;
  background-color: #ededed;
  z-index: 2;
}
.timeline-avatar svg {
  height: 1.25rem;
  width: 1.25rem;
  fill: #6b7280;
}

.timeline-no-avatar {
  display: flex;
  height: 1.75rem;
  width: 1.75rem;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: #ededed;
  z-index: 2;
  padding: 0.25rem;
}
.timeline-no-avatar svg {
  height: 1.25rem;
  width: 1.25rem;
  fill: #6b7280;
}

.text-area {
  width: 100%;
  border-radius: 0.75rem;
  padding: 0.75rem;
  box-shadow: inset 0 0 0 1px rgba(211, 211, 211, 0.5);
  border: 1px solid inset rgb(156, 163, 175);
}
.text-area:focus-within {
  box-shadow: 0 0 0 2px #078bcb;
}

.textarea-class {
  display: block;
  width: 100%;
  resize: none;
  border: none;
  background: transparent;
  color: rgb(17, 24, 39);
}
.textarea-class::placeholder {
  color: rgb(156, 163, 175);
}
.textarea-class:focus {
  outline: none;
}
@media (min-width: 640px) {
  .textarea-class {
    font-size: 0.875rem;
    line-height: 1.5;
  }
}

.update {
  display: flex;
  position: relative;
  column-gap: 1rem;
}
.update .line-container {
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  width: 1.75rem;
  justify-content: center;
  bottom: -1.5rem;
}
.update .line-container .line {
  width: 1px;
  background-color: #e5e7eb;
}
.update .line-gap {
  position: relative;
  display: flex;
  height: 1.75rem;
  width: 1.75rem;
  flex: none;
  align-items: center;
  justify-content: center;
  background-color: white;
}
.update .line-gap .status-dot {
  height: 0.375rem;
  width: 0.375rem;
  border-radius: 100%;
}
.update .comment {
  flex: auto;
  border-radius: 0.75rem;
  padding: 0.75rem;
  box-shadow: inset 0 0 0 1px rgba(211, 211, 211, 0.5);
  margin-bottom: 0.25rem;
}
.update .comment .header {
  padding-top: 0.125rem;
  font-size: 0.8rem;
  line-height: 1.25rem;
  color: #9ca3af;
  gap: 0 1rem;
}
.update .comment .header .name {
  font-weight: bold;
  color: #1f2937;
}
.update .comment .header .message {
  font-size: 0.875rem;
  line-height: 1.5rem;
}
.update .comment p {
  margin-bottom: 0;
}
.update .status {
  width: 100%;
  margin-right: 0.25rem;
}
.update .status time {
  font-size: 0.8rem;
  line-height: 1.25rem;
  color: #9ca3af;
}

.comment-box {
  display: flex;
  column-gap: 1rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.comment-box .toggle-button {
  position: relative;
  display: inline-flex;
  height: 1.5rem;
  width: 2.75rem;
  flex-shrink: 0;
  cursor: pointer;
  border-radius: 9999px;
  border: 2px solid transparent;
  transition: colors 0.2s ease-in-out;
  outline: none;
  padding: 0;
}
.comment-box .toggle-button:focus {
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.5);
}
.comment-box .toggle-button.enabled {
  background-color: #667eea;
}
.comment-box .toggle-button.not-enabled {
  background-color: #edf2f7;
}
.comment-box .toggle-button-knob {
  transform: translateX(0);
  pointer-events: none;
  display: inline-block;
  height: 1.25rem;
  width: 1.25rem;
  border-radius: 9999px;
  background-color: white;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  transition: transform 0.2s ease-in-out;
}
.comment-box .toggle-button.enabled .toggle-button-knob {
  transform: translateX(1.25rem); /* Move to the right when parent button is enabled */
}`, "",{"version":3,"sources":["webpack://./src/white-labelling/default/_variables.scss","webpack://./src/app/components/project/components/project-timeline/project-timeline.component.scss"],"names":[],"mappings":"AAiDA,sEAAA;AAYA,uBAAA;AC3DA;EACC,YAAA;AACD;;AAEA;EACC,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;AACD;AACC;EACC,yBAAA;EACA,cAAA;EACA,oDAAA;AACF;AAEC;EACC,yBAAA;EACA,cAAA;EACA,kDAAA;AAAF;;AAIA;EACC,oBAAA;EACA,mBAAA;EACA,qBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;AADD;;AAIA;EACC,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;EACA,UAAA;AADD;AAGC;EACC,eAAA;EACA,cAAA;EACA,aAAA;AADF;;AAKA;EACC,aAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,UAAA;EACA,gBAAA;AAFD;AAIC;EACC,eAAA;EACA,cAAA;EACA,aAAA;AAFF;;AAMA;EACC,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,oDAAA;EACA,0CAAA;AAHD;AAKC;EACC,6BAAA;AAHF;;AAOA;EACC,cAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,sBAAA;AAJD;AAKC;EACC,yBAAA;AAHF;AAKC;EACC,aAAA;AAHF;AAKC;EAbD;IAeE,mBAAA;IACA,gBAAA;EAHA;AACF;;AAMA;EACC,aAAA;EACA,kBAAA;EACA,gBAAA;AAHD;AAKC;EACC,kBAAA;EACA,OAAA;EACA,MAAA;EACA,aAAA;EACA,cAAA;EACA,uBAAA;EACA,eAAA;AAHF;AAKE;EACC,UAAA;EACA,yBAAA;AAHH;AAOC;EACC,kBAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;AALF;AAOE;EACC,gBAAA;EACA,eAAA;EACA,mBAAA;AALH;AAWC;EACC,UAAA;EACA,sBAAA;EACA,gBAAA;EACA,oDAAA;EACA,sBAAA;AATF;AAWE;EACC,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,cAAA;EACA,WAAA;AATH;AAWG;EACC,iBAAA;EACA,cAAA;AATJ;AAYG;EACC,mBAAA;EACA,mBAAA;AAVJ;AAcE;EACC,gBAAA;AAZH;AAgBC;EACC,WAAA;EACA,qBAAA;AAdF;AAgBE;EACC,iBAAA;EACA,oBAAA;EACA,cAAA;AAdH;;AAmBA;EACC,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;AAhBD;AAkBC;EACC,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;EACA,6BAAA;EACA,mCAAA;EACA,aAAA;EACA,UAAA;AAhBF;AAkBE;EACC,8CAAA;AAhBH;AAmBE;EACC,yBAAA;AAjBH;AAoBE;EACC,yBAAA;AAlBH;AAsBC;EACC,wBAAA;EACA,oBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,qBAAA;EACA,uBAAA;EACA,2CAAA;EACA,sCAAA;AApBF;AAuBC;EACC,8BAAA,EAAA,oDAAA;AArBF","sourcesContent":["// Core theme colors\n$primary0: #0EABF7;\n$primary: #078BCB;\n$primary2: #067ab2;\n$primary3: #05699a;\n$selectedBackground: #ebf5ff;\n\n// Colour variables\n$black: #000000;\n$border-colour: #dee2e6;\n$card-border: #dfdfdf;\n$cardBorderGrey: #d9dee8;\n$disabled: #caced5;\n$disabledButtonColor: #7bb3d0;\n$disabled-background: #ececec;\n$form-error: #f84646;\n$highlight: #f5f5f5;\n$hoverHighlight: rgba(35, 31, 32, 0.31);\n$inactive: rgba(255, 0, 0, 0.1);\n$inactiveHighlight: rgba(255, 0, 0, 0.2);\n$kaliber-dark: #414448;\n$link: #2185d0;\n$placeholder: #aab2c0;\n$selectedButton: #002865;\n$subtitle: #a0a2a4;\n$white: #ffffff;\n$cardBorderGrey: #d9dee8;\n\n// Bootstrap Colours\n$secondary: #222222;\n$dark: #7a7a7a;\n$background-light: #efefef;\n$print-page-size: auto;\n\n$danger: #d9534f;\n$muted: #85959f;\n$text-muted: #85959f;\n$success: #61f2b6;\n$warning: #f0ad4e;\n$info: #5bc0de;\n$light: #f8f9fa;\n$light-gray: #d3d3d3;\n$background-dark: #414448;\n$disabled-background: rgba(221, 221, 221, 0.3) !default;\n\n// Common Styles\n$border: 1px solid $border-colour;\n$appComsHeight: 60px;\n\n/* WARNING: This section must be updated if _variables.ts is changed */\n$target: #fcb800;\n$declined: #d11f4b;\n$active: #f77f21;\n$quoteReady: #d299c4;\n$quoteApproved: #7c4795;\n$submitted: #662066;\n$won: #3e9937;\n$lost: #00245e;\n$live: #00b0f0;\n$completed: #a9d18e;\n\n/* PERCENTAGE COLOURS */\n$percentage-green: #15b422;\n$percentage-light-green: #a3d000;\n$percentage-yellow: #fcb000;\n$percentage-red: #ff0000;\n\n// DO NOT USE IF YOU SEE THESE BEING USED. PLEASE REMOVE\n$exportTableHeight: 530px;\n$footerHeight: 60px;\n$height650px: 650px;\n$headerNavHeight: 60px;\n$headerHeight: 42px;\n$inputPercentWidth: 91px;\n$inputDiscountWidth: 126px;\n$exportTableHeight: 530px;\n$incExcTableHeight: 300px;\n$sidebarMenuWidth: 120px;\n$sideNavWidth: 67px;\n$height650px: 650px;\n$headerNavHeight: 60px;\n\n// Image References\n$loginLogo: './assets';\n","@import 'variables';\n\n.timeline {\n\theight: 100%;\n}\n\n.visibility-indicator {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tborder-radius: 6px;\n\tpadding: 0.12rem 0.25rem;\n\tfont-size: 0.7rem;\n\tfont-weight: 500;\n\tmargin-right: 0.25rem;\n\tcursor: pointer;\n\n\t&.internal {\n\t\tbackground-color: #f9fafb;\n\t\tcolor: #4b5563;\n\t\tbox-shadow: inset 0 0 0 1px rgba(107, 114, 128, 0.1);\n\t}\n\n\t&.external {\n\t\tbackground-color: #fefce8;\n\t\tcolor: #854d0e;\n\t\tbox-shadow: inset 0 0 0 1px rgba(217, 119, 6, 0.2);\n\t}\n}\n\n.add-comment-btn {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tborder-radius: 9999px;\n\tpadding: 0.25rem 0.5rem;\n\tfont-size: 0.7rem;\n\tfont-weight: 500;\n\tmargin-right: 0.25rem;\n}\n\n.timeline-avatar {\n\tposition: relative;\n\tmargin-top: 0.75rem;\n\theight: 1.75rem;\n\twidth: 1.75rem;\n\tflex: none;\n\tborder-radius: 50%;\n\tbackground-color: lighten(lightgrey, 10);\n\tz-index: 2;\n\n\tsvg {\n\t\theight: 1.25rem;\n\t\twidth: 1.25rem;\n\t\tfill: #6b7280;\n\t}\n}\n\n.timeline-no-avatar {\n\tdisplay: flex;\n\theight: 1.75rem;\n\twidth: 1.75rem;\n\talign-items: center;\n\tjustify-content: center;\n\tborder-radius: 50%;\n\tbackground-color: lighten(lightgrey, 10);\n\tz-index: 2;\n\tpadding: 0.25rem;\n\n\tsvg {\n\t\theight: 1.25rem;\n\t\twidth: 1.25rem;\n\t\tfill: #6b7280;\n\t}\n}\n\n.text-area {\n\twidth: 100%;\n\tborder-radius: 0.75rem;\n\tpadding: 0.75rem;\n\tbox-shadow: inset 0 0 0 1px rgba(lightgrey, 0.5);\n\tborder: 1px solid inset rgba(156, 163, 175, 1);\n\n\t&:focus-within {\n\t\tbox-shadow: 0 0 0 2px rgba($primary, 1); // focus-within styles\n\t}\n}\n\n.textarea-class {\n\tdisplay: block;\n\twidth: 100%;\n\tresize: none;\n\tborder: none;\n\tbackground: transparent;\n\tcolor: rgba(17, 24, 39, 1); // text-gray-900 color\n\t&::placeholder {\n\t\tcolor: rgba(156, 163, 175, 1); // placeholder:text-gray-400 color\n\t}\n\t&:focus {\n\t\toutline: none;\n\t}\n\t@media (min-width: 640px) {\n\t\t// sm breakpoint\n\t\tfont-size: 0.875rem; // sm:text-sm\n\t\tline-height: 1.5; // sm:leading-6\n\t}\n}\n\n.update {\n\tdisplay: flex;\n\tposition: relative;\n\tcolumn-gap: 1rem;\n\n\t.line-container {\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\ttop: 0;\n\t\tdisplay: flex;\n\t\twidth: 1.75rem;\n\t\tjustify-content: center;\n\t\tbottom: -1.5rem;\n\n\t\t.line {\n\t\t\twidth: 1px;\n\t\t\tbackground-color: #e5e7eb;\n\t\t}\n\t}\n\n\t.line-gap {\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t\theight: 1.75rem;\n\t\twidth: 1.75rem;\n\t\tflex: none;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tbackground-color: white;\n\n\t\t.status-dot {\n\t\t\theight: 0.375rem;\n\t\t\twidth: 0.375rem;\n\t\t\tborder-radius: 100%;\n\t\t\t//background-color: #f5f5f5;\n\t\t\t//box-shadow: 0 0 0 1px #d1d5db;\n\t\t}\n\t}\n\n\t.comment {\n\t\tflex: auto;\n\t\tborder-radius: 0.75rem;\n\t\tpadding: 0.75rem;\n\t\tbox-shadow: inset 0 0 0 1px rgba(lightgrey, 0.5);\n\t\tmargin-bottom: 0.25rem;\n\n\t\t.header {\n\t\t\tpadding-top: 0.125rem;\n\t\t\tfont-size: 0.8rem;\n\t\t\tline-height: 1.25rem;\n\t\t\tcolor: #9ca3af;\n\t\t\tgap: 0 1rem;\n\n\t\t\t.name {\n\t\t\t\tfont-weight: bold;\n\t\t\t\tcolor: #1f2937;\n\t\t\t}\n\n\t\t\t.message {\n\t\t\t\tfont-size: 0.875rem; // text-sm\n\t\t\t\tline-height: 1.5rem; // leading-6\n\t\t\t}\n\t\t}\n\n\t\tp {\n\t\t\tmargin-bottom: 0;\n\t\t}\n\t}\n\n\t.status {\n\t\twidth: 100%;\n\t\tmargin-right: 0.25rem;\n\n\t\ttime {\n\t\t\tfont-size: 0.8rem;\n\t\t\tline-height: 1.25rem;\n\t\t\tcolor: #9ca3af;\n\t\t}\n\t}\n}\n\n.comment-box {\n\tdisplay: flex;\n\tcolumn-gap: 1rem;\n\tpadding-top: 1rem;\n\tpadding-bottom: 1rem;\n\n\t.toggle-button {\n\t\tposition: relative;\n\t\tdisplay: inline-flex;\n\t\theight: 1.5rem; // Equivalent to h-6\n\t\twidth: 2.75rem; // Equivalent to w-11\n\t\tflex-shrink: 0;\n\t\tcursor: pointer;\n\t\tborder-radius: 9999px; // Equivalent to rounded-full\n\t\tborder: 2px solid transparent;\n\t\ttransition: colors 0.2s ease-in-out; // Equivalent to transition-colors duration-200 ease-in-out\n\t\toutline: none;\n\t\tpadding: 0;\n\n\t\t&:focus {\n\t\t\tbox-shadow: 0 0 0 2px rgba(102, 126, 234, 0.5); // Equivalent to focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2\n\t\t}\n\n\t\t&.enabled {\n\t\t\tbackground-color: #667eea; // Equivalent to bg-indigo-600\n\t\t}\n\n\t\t&.not-enabled {\n\t\t\tbackground-color: #edf2f7; // Equivalent to bg-gray-200\n\t\t}\n\t}\n\n\t.toggle-button-knob {\n\t\ttransform: translateX(0); // Equivalent to translate-x-0\n\t\tpointer-events: none;\n\t\tdisplay: inline-block;\n\t\theight: 1.25rem; // Equivalent to h-5\n\t\twidth: 1.25rem; // Equivalent to w-5\n\t\tborder-radius: 9999px; // Equivalent to rounded-full\n\t\tbackground-color: white;\n\t\tbox-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05); // Equivalent to shadow\n\t\ttransition: transform 0.2s ease-in-out;\n\t}\n\n\t.toggle-button.enabled .toggle-button-knob {\n\t\ttransform: translateX(1.25rem); /* Move to the right when parent button is enabled */\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
